import ActionCable from 'actioncable';
import { Effect } from 'redux-saga/effects';

import {
  eventChannel,
} from 'redux-saga';
import * as eff from 'redux-saga/effects';

import {
  User,
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import config from 'web-config';

const cableChannel = ({
  cable,
  channel,
  room,
}: {
  cable: any,
  room?: string,
  channel: string,
}) => eventChannel(
  received => {
    const subscription = cable.subscriptions.create({ channel, room }, { received });

    return () => {
      cable.subscriptions.remove(subscription);
    };
  },
);

function* messages({ message }: any): Generator<Effect, void, any> {
  const unread = yield eff.select(
    coreSelectors.getResourceMeta('conversations', 'unread'),
  );
  const conversation = yield eff.select(
    coreSelectors.getResourceById('conversations', message.conversation_id),
  );

  if (!conversation) {
    yield eff.put(
      coreActions.requestConversationList(),
    );
  } else {
    // remove old
    yield eff.put(
      coreActions.deleteResources({
        resourceType: 'conversations',
        resources: [conversation],
      }),
    );
    yield eff.put(
      coreActions.addResources({
        resourceType: 'conversations',
        resources: [{
          ...conversation,
          updated_at: message.updated_at,
          last_message: {
            ...conversation.last_message,
            body: message.body,
            message_category: message.message_category,
          },
        }],
      }),
    );
  }
  const isPro = yield eff.select(
    coreSelectors.getProfile('is_pro'),
  );

  if (isPro) {
    yield eff.put(
      coreActions.requestUnreadCategories({
        id: message.conversation_id,
      }),
    );

    yield eff.put({
      type: coreActions.resourceActionTypes.UPDATE_RESOURCES,
      meta: {
        conversations: {
          unread: {
            count: unread.count + 1,
          },
        },
      },
    });
  }

  yield eff.put(
    coreActions.addResources({
      list: `${message.conversation_id}_${message.message_category}`,
      resources: [message],
      resourceType: 'messages',
    }),
  );
}

function* vimeoUpload(result: any) {
  yield eff.put(
    coreActions.updateResources({
      resources: [result],
      resourceType: 'videos',
    }),
  );
}

function* userSettings(result: any) {
  yield eff.put(
    coreActions.setProfileState({
      user_settings: result,
    }),
  );
}

function* notifications(result: any) {
  console.log('notifications', result);

  yield null;
}

function* namespaceSettings() {
  console.log("Settings from room")
  yield eff.put(coreActions.requestFetchProfile());
}

function* initCommonChannels(cable: ActionCable.Cable): Generator<Effect, void, any> {
  const channels = yield eff.all({
    messagesChannel: eff.call(cableChannel, { cable, channel: 'MessagesChannel' }),
    vimeoUploadChannel: eff.call(cableChannel, { cable, channel: 'VimeoUploadChannel' }),
    userSettingsChannel: eff.call(cableChannel, { cable, channel: 'UserSettingsChannel' }),
    notificationsChannel: eff.call(cableChannel, { cable, channel: 'NotificationsChannel' }),
  });

  yield eff.all([
    eff.takeEvery(channels.messagesChannel, messages),
    eff.takeEvery(channels.vimeoUploadChannel, vimeoUpload),
    eff.takeEvery(channels.userSettingsChannel, userSettings),
    eff.takeEvery(channels.notificationsChannel, notifications),
  ]);
}

function* initNamespaceSettingsChannel(
  cable: ActionCable.Cable,
  user: User,
): Generator<Effect, void, any> {
  let groupId = user.id;

  if (!user.is_pro) {
    const { pro } = yield eff.take(coreActions.actionTypes.REQUEST_FETCH_PRO_SUCCESS);
    groupId = pro.id;
  }

  const namespaceSettingsChannel = yield eff.call(cableChannel, {
    cable,
    channel: 'UserNamespaceSettingsChannel',
    room: `pro_group_${groupId}_settings`,
  });

  yield eff.takeEvery(namespaceSettingsChannel, namespaceSettings);
}

export default function* cableFlow({
  user,
}: {
  user: User,
}): Generator<Effect, void, any> {
  const accessToken = yield eff.call([localStorage, 'getItem'], 'accessToken');
  const cable = ActionCable.createConsumer(`${config.wsUrl}?${accessToken}`);

  yield* initCommonChannels(cable);
  yield* initNamespaceSettingsChannel(cable, user);
}
